const baseURL = {
    // 测试地址前缀 最后记得加 /
    dev_baseURL: "https://gwb.scxjkj.net/intf/",
    // 线上地址前缀 最后记得加 /
    bul_baseUrl: "https://gwb.scxjkj.net/intf/"
}

export default {
    baseURL: baseURL.dev_baseURL
}